<template>
  <div class="login">
    <div class="login_con_top"></div>
    <div class="login_con" v-loading="qyloading">
      <div class="m-login-panel">
        <div v-if="inputShow">
          <div class="qr-tip">切换至密码登录</div>
          <a class="qr-code-is" @click="inputOrShow"></a>
        </div>
        <div v-else>
          <div class="qr-tip">扫码登录更便捷</div>
          <a class="qr-code" @click="inputOrShow"></a>
        </div>
        <div style="text-align: right;float: left;" class="back_index">
          <router-link :to="{path:'/'}">返回首页</router-link>
        </div>
        <div id="qrcodeImg" class="qrcode" v-if="inputShow" title="扫码登录"></div>
        <div class="iframe-wrap" v-else>
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_name">
              <el-input type="text" v-model="formData.username" placeholder="请输入账号或手机号码" maxlength="11"></el-input>
            </div>
          </div>
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_pass">
              <el-input type="password" v-model="formData.password" placeholder="请输入您设置的登录密码" @keyup.enter.native="login"></el-input>
            </div>
          </div>
        </div>
        <div class="out-time" v-if="isTimeout">
          <p>二维码已失效</p>
          <div class="refresh" @click="refreshCode">刷新</div>
        </div>
        <!-- <div class="login_con_pub">
          <div class="login_con_pub_info login_con_pub_yzm">
            <input type="text" name="" placeholder="请输入验证码" field="code" bs="{valdate:true}" mess="验证码" maxlength="4">
            <a href="javascript:;"><img src="{:captcha_src()}" id="verify_img" onclick="refreshVerify()" width="100" height="50"></a>
          </div>
        </div> -->
        <!-- <img src="../../assets/images/wechat.png" style="width: 32px;height: 32px;cursor: pointer;margin-top: 20px;" > -->
        <a class="login_con_loginbtn" href="javascript:;" @click="login" v-if="!inputShow">
          登&emsp;&emsp;录
        </a>
        <div class="scan-tip" v-if="inputShow">
          <img src="../../assets/images/saoyiha.png" style="width: 48px;height: 48px;">
          <div class="stp">打开手机<span style="color: #E1251B">微信</span>扫描二维码</div>
        </div>
        <div class="login_wjmm clearfix">
          <router-link :to="{path:'/Forget'}" class="wjmm_btn">忘记密码？</router-link>
          <router-link :to="{path:'/Register'}" class="reg_btn">免费注册</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLoginToken, wxlogins } from '@/api/login'
// import { setToken } from '@/utils/auth'
import QRcode from 'qrcodejs2'

export default {
  name: 'Login',
  data () {
    return {
      isTimeout: false,
      formData: {
        username: '',
        password: ''
      },
      redirect: this.$route.query.return_url,
      qyloading: false,
      redismsg: '',
      inputShow: false
    }
  },
  mounted () {

  },
  methods: {
    refreshCode () {
      this.isTimeout = false
      clearTimeout(this.timer)
      document.getElementById('qrcodeImg').innerHTML = ''
      this.getLogin_Token()
    },
    inputOrShow () {
      this.inputShow = !this.inputShow
      if (this.inputShow) {
        this.getLogin_Token()
      } else {
        clearTimeout(this.timer)
        document.getElementById('qrcodeImg').innerHTML = ''
        this.isTimeout = false
      }
    },
    getLogin_Token () {
      getLoginToken().then(res => {
        this.redismsg = res.items
        // var callback_url = 'http://serv.nmzp.com/wap/cart/getWechat?userid=' + userId + '&return_url=' + encodeURIComponent(tbis_url)
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + 'wx6573f24600969b7a' + '&redirect_uri=' + encodeURIComponent(callback_url) + '&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect'
        this.creatQrCode('https://serv.nmzp.com/home/login/requestWechat?tk=' + res.items) // 二维码
        this.setTimer()// 开启定时任务
      })
    },
    /** 定时器 */
    setTimer () {
      this.timer = setInterval(() => {
        this.getAppScanResult()
      }, 2000)
    },
    creatQrCode (code) {
      return new QRcode('qrcodeImg', {
        width: 150,
        height: 150,
        text: code,
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    /** 刷新二维码重新获取 */
    refresh () {
      document.getElementById('qrcodeImg').innerHTML = '' // 把之前的置为空
      this.getFaceSnap()
    },
    /* 查询二维码状态 */
    getAppScanResult () {
      wxlogins({tk: this.redismsg}).then(res => {
        if (res.cods === 1) {
          clearTimeout(this.timer)
          this.isTimeout = true
        } else if (res.cods === 3) {
          clearTimeout(this.timer)
          this.$store.dispatch('user/getWechat', res.item).then(() => {
            this.qyloading = false
            this.$router.push({ path: this.redirect || '/' })
          }).catch((err) => {
            this.qyloading = false
            console.info(err)
          })
        }
      })
    },
    login () {
      if (!this.formData.username) {
        this.$message.error('账号不能为空')
        return
      }
      if (!this.formData.password) {
        this.$message.error('密码不能为空')
        return
      }
      if (this.qyloading) {
        return
      }
      this.qyloading = true
      this.$store.dispatch('user/login', this.formData).then(() => {
        this.$router.push({ path: this.redirect || '/' })
        this.qyloading = false
      }).catch((err) => {
        this.qyloading = false
        console.info(err)
      })
    }
  }
}
</script>
<style scoped>
.out-time{
  position: absolute;
  left: 88px;
  top: 90px;
  width: 150px;
  height: 150px;
  background: rgba(0,0,0,.45);
  text-align: center;
}
.out-time p {
  margin-top: 50px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
.out-time .refresh {
  margin: 8px auto 0;
  width: 84px;
  height: 24px;
  background: #ed2920;
  border-radius: 2px;
  line-height: 24px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
}
.scan-tip{
  height: 48px;
  width: 300px;
  margin-top: 15px;
  text-align: center;
}
.scan-tip .stp{
  display: inline-block;
  width: 110px;
  vertical-align: super;
  font-size: 14px;
}
#qrcodeImg{
  display: inline-block;
}
.iframe-wrap{
  position: relative;
  height: 150px;
  top:50px;
}
.m-login-panel .qr-tip{
  position: absolute;
  right: 88px;
  top: 24px;
  width: 112px;
  height: 28px;
  background: url(../../assets/images/tip2x.png) no-repeat 50%;
  background-size: 112px;
  line-height: 28px;
  font-size: 12px;
  font-weight: 400;
  color: #fa210a;
  padding-left: 10px;
  box-sizing: border-box;
}
.m-login-panel .qr-code{
  position: absolute;
  right: 0;
  top: 0;
  width: 96px;
  height: 96px;
  background: url(../../assets/images/qr-code2x.png) no-repeat 50%;
  background-size: 64px;
  cursor: pointer;
}
.m-login-panel .qr-code-is{
  position: absolute;
  right: 0;
  top: 0;
  width: 96px;
  height: 96px;
  background: url(../../assets/images/pc-login2x.png) no-repeat 50%;
  background-size: 64px;
  cursor: pointer;
}
.qrcode{
  text-align: center;
  margin-top: 60px;
  text-align: center;
  margin-left: 15px;
  position: relative;
}
.m-login-panel {
  overflow: hidden;
  margin-left: 40px;
  padding: 30px 25px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  min-height: 340px;
  border: 1px solid #eceded;
  box-shadow: 10px 10px 12px 0px rgb(0 55 156 / 15%);
}
.login_con_pub{
  margin-top: 20px;
}
.login_con_pub_info.login_con_pub_name{
  background-size: 18px;
}
.login_con_pub_info.login_con_pub_pass{
  background-size: 18px;
}
.login_con_pub_info input{
  height: 30px !important;
  line-height: 30px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue